import { TagEntity } from '@/entities/interfaces/tag';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useTagStore = defineStore('tags', () => {
  const tags = ref<TagEntity[]>();

  const getTags = computed(() => tags);

  const setTags = (action: TagEntity[]) => {
    tags.value = action;
  };

  const getEventTags = (action: string) => {
    const tagsList = action.split(',');
    return tags.value?.filter((tag) => tagsList.includes(tag.id));
  };

  return {
    tags,
    setTags,
    getTags,
    getEventTags
  };
});
